import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface LoadingScreenProps {
  isLoading: boolean;
}
export function LoadingScreen({
  isLoading
}: LoadingScreenProps) {
  const [progress, setProgress] = useState(0);
  const [shouldShow, setShouldShow] = useState(true);
  useEffect(() => {
    // Check if this is the first visit in this session
    const hasVisited = sessionStorage.getItem('hasVisited');
    if (hasVisited) {
      setShouldShow(false);
    } else {
      sessionStorage.setItem('hasVisited', 'true');
    }
  }, []);
  useEffect(() => {
    if (isLoading && shouldShow) {
      const interval = setInterval(() => {
        setProgress(prev => {
          if (prev >= 100) {
            clearInterval(interval);
            return 100;
          }
          return prev + Math.random() * 15;
        });
      }, 50);
      return () => clearInterval(interval);
    }
  }, [isLoading, shouldShow]);
  if (!shouldShow) {
    return null;
  }
  return <AnimatePresence data-id="element-201">
      {isLoading && <motion.div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black" initial={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.5
    }} data-id="element-202">
          <motion.div className="flex flex-col items-center gap-8" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-203">
            <Logo data-id="element-204" />
            <div className="w-64 space-y-4" data-id="element-205">
              <div className="h-1 bg-white/10 rounded-full overflow-hidden" data-id="element-206">
                <motion.div className="h-full bg-gradient-to-r from-purple-500 to-cyan-500" initial={{
              width: '0%'
            }} animate={{
              width: `${Math.min(progress, 100)}%`
            }} transition={{
              duration: 0.3,
              ease: 'easeOut'
            }} data-id="element-207" />
              </div>
              <motion.div className="text-center text-2xl font-medium text-white" key={Math.floor(progress)} data-id="element-208">
                {Math.floor(Math.min(progress, 100))}%
              </motion.div>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
const Logo = () => {
  return <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bWFakPm72iGj7zFK9vUdN4/vantaeg2.png" alt="ProviderMDM" className="h-12 w-auto" data-id="element-209" />;
};